/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const OfferingExemptionJsonApiModel = {
  id: "",
  slug: "",
  name: "",
  "long-name": "",
  "created-at": "",
  "updated-at": "",
};
